import ApiService from './api.service'

const InventoryService = {

  /***
   * Get infrastructure inventory items
   * @returns {*}
   */
  getInfra () {
    return ApiService.get('inventory/infra')
  },
}
export default InventoryService
